export { createJSDoc } from '@kubb/fabric-core'
